<template>
  <div class="goal-cycle-list">
    <div class="_items">
      <template
        v-for="(group, index) in cycleGroups"
        :key="index"
      >
        <m-card-group
          :title="group.title"
          :expanded="expandAll === true || index === 0 || groupHasItem(group, selected)"
          @toggle-show="handleToggleShow"
        >
          <div
            v-if="group.children.length === 0"
            class="_empty"
          >
            {{ $t('goalCycleSelector.emptyGroup') }}
          </div>
          <selector-item
            v-for="item in group.children"
            :key="item.uid"
            :item="item"
            :selected="selected"
            :selectable="selectable"
            :level="0"
            @select="select"
          />
        </m-card-group>
      </template>
      <selector-item
        v-if="withUnassigned"
        :item="unassignedCycle"
        :selected="selected"
        :level="-1"
        :selectable="selectable"
        @select="select"
      />
      <m-card-item
        v-if="cycleGroups.length === 0 && !withUnassigned"
        disabled
      >
        {{ $t('general.noResults') }}
      </m-card-item>
    </div>
  </div>
</template>

<script>
import SelectorItem from '@/components/goal/cycle/SelectorItem.vue';
import useUnassignedGoalCycle from '@/composables/goal-cycle/unassigned-goal-cycle';
import { intersection } from 'shared/lib/array/array';

export default {
  name: 'GoalCycleList',
  props: {
    cycleGroups: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    withUnassigned: {
      type: Boolean,
      default: false,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { unassignedCycle } = useUnassignedGoalCycle();
    return { unassignedCycle };
  },
  components: { SelectorItem },
  emits: ['select', 'toggle-show'],
  methods: {
    handleToggleShow(val) {
      this.$emit('toggle-show', val);
    },
    groupHasItem(group, item) {
      return intersection(item.map((c) => c.uid), group.children.map((c) => c.uid)).length > 0;
    },
    select(item) {
      if (!this.selectable) {
        return;
      }

      if (!this.multiple) {
        if (this.selected.map((c) => c.uid).includes(item.uid)) {
          this.$emit('select', []);
          return;
        }
        this.$emit('select', [item]);
        return;
      }

      const otherItems = this.selected.filter((c) => c.uid !== item.uid);
      if (otherItems.length === this.selected.length) {
        this.$emit('select', [...otherItems, item]);
        return;
      }

      this.$emit('select', otherItems);
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .goal-cycle-list {
    ._items {
      max-height: 60vh;
      padding: .4rem 0;
      overflow: auto;

      @media (max-width: $screen-size-sm) {
        max-height: var(--viewport-height-100);
      }
    }

  }
</style>
